var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarForInput(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7334 1.8125H13.9834C14.9154 1.8125 15.6709 2.56802 15.6709 3.5V13.625C15.6709 14.557 14.9154 15.3125 13.9834 15.3125H2.7334C1.80142 15.3125 1.0459 14.557 1.0459 13.625V3.5C1.0459 2.56802 1.80142 1.8125 2.7334 1.8125Z",
    stroke: "#E46869",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95215 8C6.48616 8 6.1084 7.62224 6.1084 7.15625C6.1084 6.69026 6.48616 6.3125 6.95215 6.3125C7.41814 6.3125 7.7959 6.69026 7.7959 7.15625C7.7959 7.62224 7.41814 8 6.95215 8Z",
    fill: "#E46869"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13965 8C3.67366 8 3.2959 7.62224 3.2959 7.15625C3.2959 6.69026 3.67366 6.3125 4.13965 6.3125C4.60564 6.3125 4.9834 6.69026 4.9834 7.15625C4.9834 7.62224 4.60564 8 4.13965 8Z",
    fill: "#E46869"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95215 10.8125C6.48616 10.8125 6.1084 10.4347 6.1084 9.96875C6.1084 9.50276 6.48616 9.125 6.95215 9.125C7.41814 9.125 7.7959 9.50276 7.7959 9.96875C7.7959 10.4347 7.41814 10.8125 6.95215 10.8125Z",
    fill: "#E46869"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13965 10.8125C3.67366 10.8125 3.2959 10.4347 3.2959 9.96875C3.2959 9.50276 3.67366 9.125 4.13965 9.125C4.60564 9.125 4.9834 9.50276 4.9834 9.96875C4.9834 10.4347 4.60564 10.8125 4.13965 10.8125Z",
    fill: "#E46869"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5771 10.8125C12.1112 10.8125 11.7334 10.4347 11.7334 9.96875C11.7334 9.50276 12.1112 9.125 12.5771 9.125C13.0431 9.125 13.4209 9.50276 13.4209 9.96875C13.4209 10.4347 13.0431 10.8125 12.5771 10.8125Z",
    fill: "#E46869"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76465 10.8125C9.29866 10.8125 8.9209 10.4347 8.9209 9.96875C8.9209 9.50276 9.29866 9.125 9.76465 9.125C10.2306 9.125 10.6084 9.50276 10.6084 9.96875C10.6084 10.4347 10.2306 10.8125 9.76465 10.8125Z",
    fill: "#E46869"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5771 13.625C12.1112 13.625 11.7334 13.2472 11.7334 12.7812C11.7334 12.3153 12.1112 11.9375 12.5771 11.9375C13.0431 11.9375 13.4209 12.3153 13.4209 12.7812C13.4209 13.2472 13.0431 13.625 12.5771 13.625Z",
    fill: "#E46869"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76465 13.625C9.29866 13.625 8.9209 13.2472 8.9209 12.7812C8.9209 12.3153 9.29866 11.9375 9.76465 11.9375C10.2306 11.9375 10.6084 12.3153 10.6084 12.7812C10.6084 13.2472 10.2306 13.625 9.76465 13.625Z",
    fill: "#E46869"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95215 13.625C6.48616 13.625 6.1084 13.2472 6.1084 12.7812C6.1084 12.3153 6.48616 11.9375 6.95215 11.9375C7.41814 11.9375 7.7959 12.3153 7.7959 12.7812C7.7959 13.2472 7.41814 13.625 6.95215 13.625Z",
    fill: "#E46869"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8584 0.6875V1.8125M3.8584 0.6875V1.8125",
    stroke: "#E46869",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0459 4.625H15.6709",
    stroke: "#E46869",
    strokeWidth: 1.125,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarForInput);
export default __webpack_public_path__ + "static/media/calendarForInput.27ae8da7f2b2ef4b857d2a56fea4afcd.svg";
export { ForwardRef as ReactComponent };